import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// Define your styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
    backgroundColor: "#f7f7f7", // Soft background color
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 20,
    textAlign: "center",
  },
  sectionHeader: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#2980b9",
    marginBottom: 10,
  },
  sectionSubHeader: {
    fontSize: 14,
    color: "#34495e",
    marginBottom: 5,
  },
  sectionInfo: {
    padding: 15,
    backgroundColor: "#ecf0f1", // Light background for info sections
    borderRadius: 8,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: 25,
  },
  table: {
    width: "100%",
    marginBottom: 20,
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  tableHeader: {
    backgroundColor: "#3498db",
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
    paddingVertical: 10,
  },
  tableRow: {
    flexDirection: "row",
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#bdc3c7",
    backgroundColor: "#fff",
  },
  tableCell: {
    flex: 1,
    padding: 10,
    textAlign: "center",
    fontSize: 12,
    color: "#34495e",
    borderRightWidth: 1,
    borderRightColor: "#bdc3c7",
  },
  tableCellNoBorder: {
    borderRightWidth: 0,
  },
  statusText: {
    fontWeight: "bold",
    color: "#e74c3c",
  },
  tableRowEven: {
    backgroundColor: "#ecf0f1", // Light alternate row color
  },
  tableRowHeader: {
    backgroundColor: "#3498db",
    color: "#fff",
  },
});

function EligibilityQuizPdf({ data }) {
  return (
    <Document>
      <Page style={styles.page}>
        <Text style={styles.title}>Eligibility Quiz Details</Text>

        {data.map((item) => (
          <View key={item._id}>
            {/* Scholarship Information */}
            <View style={styles.sectionInfo}>
              <Text style={styles.sectionHeader}>{item.title}</Text>
              <Text style={styles.sectionSubHeader}>
                Attempts: {item.attempt} of {item.numberOfAttempts}
              </Text>
              <Text style={styles.sectionSubHeader}>
                Status:{" "}
                <Text style={styles.statusText}>
                  {item.status === 1 ? "Active" : "Inactive"}
                </Text>
              </Text>
              <Text style={styles.sectionSubHeader}>
                Created On: {item.createdAt}
              </Text>
              <Text style={styles.sectionSubHeader}>
                Number of Questions: {item.numberOfQuestions}
              </Text>
            </View>

            {/* Questions Table */}
            <View style={styles.table}>
              <View style={[styles.tableRow, styles.tableRowHeader]}>
                <Text style={[styles.tableCell, styles.tableCellNoBorder]}>
                  Serial Number
                </Text>
                <Text style={styles.tableCell}>Question</Text>
              </View>

              {item.questionDetails.map((question, qIndex) => (
                <View
                  key={qIndex}
                  style={[
                    styles.tableRow,
                    qIndex % 2 === 0 ? styles.tableRowEven : {},
                  ]}
                >
                  <Text style={[styles.tableCell, styles.tableCellNoBorder]}>
                    {qIndex + 1}
                  </Text>
                  <Text style={styles.tableCell}>{question.title}</Text>
                </View>
              ))}
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
}

export default EligibilityQuizPdf;
